import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

export interface IOption {
  displayName: string;
  section: string;
  icon: string;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent {
  options: IOption[] = [
    { displayName: 'About', section: 'about', icon: 'person' },
    { displayName: 'Technologies', section: 'skills', icon: 'code' },
    { displayName: 'Experience', section: 'experience', icon: 'apartment' },
    { displayName: 'Projects', section: 'projects', icon: 'handyman' },
    { displayName: 'Certificates', section: 'certificates', icon: 'verified' },
    { displayName: 'interests', section: 'Interests', icon: 'interests' },
    { displayName: 'Contact', section: 'contact', icon: 'forum' },
    { displayName: 'Resume', section: 'resume', icon: 'article' },
  ];

  constructor(private _sharedService: SharedService) { }

  optionSelected(section: string): void {
    if (section === 'resume') {
      // download resume
      this.downloadResume();
    } else {
      const element = document.getElementById('sidebarBtn') as HTMLElement;
      element.click();
      const el = document.getElementById(section) as HTMLElement;
      el.scrollIntoView();
    }
  }

  private downloadResume(): void {
    this._sharedService.downloadResume();
  }
}
